module.exports = __webpack_public_path__ + "static/media/adserver_logo.a93504b0.png";